module.exports = __webpack_public_path__ + "img/scb-bank46x46.d17e516d.jpg";